$(window).on('load', function(){
    $('.owl-carousel').owlCarousel({
        dots: false,
        // nav: true,
        loop: true,
        items: 1,
        autoplay: true,
        autoplaySpeed: 1000,
        autoplayHoverPause: true,
        lazyLoad: true,
        // responsiveClass: true,

        responsive: {
            960: {
                autoWidth: true
            }
        }
    });
});

var basesOwl = $('#TEMPUR-Bases .owl-carousel');
var pillowsOwl = $('#TEMPUR-Pillows .owl-carousel');

// Change on click
$('.available-in__bases a[data-slide]').click(function(e) {
	e.preventDefault();
    var slideno = $(this).data('slide');
    basesOwl.trigger('to.owl.carousel', slideno);
	$('.available-in__bases a').removeClass(" active");
	$(this).addClass(" active");
});

$('.available-in__pillows a[data-slide]').click(function(e) {
    e.preventDefault();
    var slideno = $(this).data('slide');
    pillowsOwl.trigger('to.owl.carousel', slideno);
    $('.available-in__pillows a').removeClass(" active");
    $(this).addClass(" active");
});


// Change automatically
$(basesOwl).on("changed.owl.carousel", function(event) {
    var $item = event.item.index - 3;

    //remove all active classes
    $('.available-in__bases a').removeClass(" active");

    //if current slide equals available-in base a[data-slide], give a the active class
    $('.available-in__bases a[data-slide=' + $item + ']').addClass(" active");

    // if data is 5, make the dots gray
    if ($item > 4) {
    	$("#TEMPUR-Bases button.owl-dot").addClass(" gray");
    } else {
    	$("#TEMPUR-Bases button.owl-dot").removeClass(" gray");
    }
});

$(pillowsOwl).on("changed.owl.carousel", function(event) {
    var $item = event.item.index - 4;

    //remove all active classes
    $('.available-in__pillows a').removeClass(" active");

    //if current slide equals available-in base a[data-slide], give a the active class
    $('.available-in__pillows a[data-slide=' + $item + ']').addClass(" active");

    // if data is 5, make the dots gray
    if ($item > 4) {
        $("#TEMPUR-Pillows button.owl-dot").addClass(" gray");
    } else {
        $("#TEMPUR-Pillows button.owl-dot").removeClass(" gray");
    }
});

